import { ready } from '../helpers/jQueryReplacements';

ready(() => {
  const addDropCapElements = document.querySelectorAll('.add-drop-cap');

  addDropCapElements.forEach((el) => {
    // find the first direct descendent of the element that is a `p` tag
    // NOTE: this assumes that the first p tag is the start of the body
    const firstP = Array.from(el.children).find((desc) => (
      desc.matches('p')
    ));
    firstP.classList.add('drop-cap');
  });
});
